<template>
  <div class="kalem">
    <imagefiledialog ref="imagefiledialog"></imagefiledialog>
    <loadingcomp mesaj="Voucher" v-model="loadingStatus"></loadingcomp>
    <snackbarcomp v-bind:mesaj="mesaj" v-model="snackbar"></snackbarcomp>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-toolbar class="baslik" size="120px" dark color="info">
      <v-toolbar-title class="baslikfont">Voucher</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 md12 sm12>
          <v-layout row wrap>
            <v-flex pa-2 xs12 sm12>
              <v-card>
                <v-layout row wrap>
                  <v-flex xs12 pa-2 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 md12>
                        <v-layout row wrap class="pl-1 pr-1 project overdue">
                          <v-flex pa-2 md12 xs12 sm12>
                            <v-layout row wrap>
                             
                              <v-flex md4 xs12 sm12>
                              <v-autocomplete
                              @change="voucherLoad2()" 
                              clearable
                              v-model="secilenVoucherObje"
                              :items="itemsVoucherSaticilar"
                              label="Voucher Seçiniz"
                              item-value="name"
      item-text="name"
      return-object
                              append-icon="search"
                              hide-details
                              
                            >
                              <template slot="item" slot-scope="data">
                                <v-icon >{{ data.item.icon }} </v-icon>
                              
                                {{ data.item.name }}
                              </template>
                            </v-autocomplete>

                              </v-flex>
                                <v-flex md2 xs12 sm12>
                                   <v-select :label="$t('Language-select')" :items="locales" hide-details="" v-model="locale" item-text="title" item-value="locale"></v-select>
                              </v-flex>
                                  <v-flex md4 xs12 sm12>
                                    <v-checkbox label="Her Satış Kalemi için farklı voucher bas" @change="getVoucher()" v-model="KalemDetay"></v-checkbox>
                              </v-flex>
                                  <v-flex md2 xs12 sm12>
                                    <v-checkbox v-model="IsimleriAyir" label="İsimleri Ayır" @change="getVoucher()"></v-checkbox>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex xs10 pa-2 sm10 v-if="locale == 'tr' && vouchergoster">
              <v-card flat>
                <v-layout justify-end row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <div id="printJS-form">
                      <table
                        style="page-break-after: always"
                        v-for="item in selectedVoucherItems.Sayfalar"
                        :key="item.id"
                        width="100%"
                      >
                        <thead
                          v-if="item.Satici.Kod.trim() == secilenSaticiKod.trim()"
                          class="print"
                        >
                          <tr>
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 100%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                    id="imgUst"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="10"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                              <span v-if="isOtel" class="black--text title">
                                OTEL VOUCHER </span
                              >
                               <span v-if="isAcente" class="black--text title">
                                ACENTE VOUCHER </span
                              >
                              <span v-if="isRestaurant" class="black--text title">
                                RESTAURANT VOUCHER </span
                              >
                              <span v-if="isTransfer" class="black--text title">
                                TRANSFER VOUCHER </span
                              >
                               <span v-if="isRentACar" class="black--text title">
                                RENT A CAR VOUCHER </span
                              >
                              

                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                   Firma Adı
                                  </td>

                                  <td style="width: 35%">
                                    {{ item.Satici.Isim }}
                                  </td>

                                  <td style="width: 15%">Telefon</td>

                                  <td style="width: 35%" align="left">
                                    {{ item.Satici.Tel1 }} /
                                    {{ item.Satici.Tel2 }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                   Firma Adresi
                                  </td>
                                  <td style="width: 35%">
                                    {{ item.Satici.Adres }} &nbsp;
                                    {{ item.Satici.Yer }} &nbsp;
                                    {{ item.Satici.Sehir }} &nbsp;
                                    {{ item.Satici.Ulke }}
                                  </td>
                                  <td style="width: 15%">
                                    Email
                                  </td>
                                  <td style="width: 35%" align="left">-</td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                            </tr>
                            <td v-if="isOtel" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      Oda Sıra</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Pnr No</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Kişi Tip </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      İsim </span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{$t('Check-in-Date')}}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                    {{ $t('Check-out-Date') }} </span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      Gece </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{$t('Room-Type')}} </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-if="isAcente" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      İsim</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Rezervasyon</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Uyruk </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Pasaport No </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Doğum Tarihi</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-if="isRestaurant" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Pax</span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      İsim</span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Karşı Rez. Kod. </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      İsim</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Uyruk </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Pasaport No </span
                                    >
                                  </td>
                                    <td style="width: 20%">
                                    <span class="subheading">
                                      Doğum Tarihi </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-if="isRentACar" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      İsim</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Arac </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Kategori </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Adet </span
                                    >
                                  </td>
                                    <td style="width: 20%">
                                    <span class="subheading">
                                      Gün </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            
                          </tr>

                          <tr v-if="isOtel">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      {{ itemoda.Sira }}</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      {{ KisiTipToStr(itemkisi.kisiTip) }}
                                    </span>
                                  </td>
                                  <td
                                    align="left"
                                    style="align: left; width: 20%"
                                  >
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem1 | dateformat }}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem2 | dateformat }}</span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      {{ gunhesapla(itemoda.Kalem) }}</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{
                                        PansiyonTipToStr(
                                          itemoda.Kalem.kalemOtel.pansiyon
                                        )
                                      }}{{
                                        itemoda.Kalem.kalemOtel.odaTipi.isim
                                      }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>

                          <tr v-if="isAcente">
                            <td colspan="5">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{ itemkisi.kod }}</span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                       {{ itemkisi.ulke }}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{ itemkisi.pasaportNo }}</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi) }} </span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>


                           <tr v-if="isRestaurant">
                            <td colspan="4"  >
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      {{ itemkisi.Pax }} 
                                      </span>
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading"> {{ itemkisi.adSoyad }}</span>
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      {{ pnr }}    
                                    </span>
                                  </td>
                                  <td style="width: 25%" >
                                    <span class="subheading">
                                      {{ itemoda.KarsiRezKodu }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                         <tr v-if="isTransfer">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{itemkisi.ulke}}  
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemkisi.pasaportNo}}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi)}}
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr v-if="isRentACar">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{itemoda.Kalem.baseKalem.arac}} </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.kategori}}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.aracAdet}} 
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.gun}} 
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr>
                            <td colspan="4" v-if="isOtel">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Toplam Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="8"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Toplam Oda : {{ toplamOdaText }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td colspan="5" v-if="isAcente">
                              <table align="left" width="100%">
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Toplam Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Tur Tipi : {{ getTurTipi(item.Odalar[0].Kalem.kalemAcente.TurTipi) }} </span
                                    >
                                  </td>
                                </tr>
                                 <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Bulusma Tarihi : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaTarihi | dateformat }} </span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Tur Türü : {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.TurTuru) }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Bulusma Saati : {{ item.Odalar[0].Kalem.kalemAcente.Saat | timeformat }} </span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Tur Süresi :  </span 
                                    >
                                    <!-- {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.Tip) }} -->
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Bulusma Yeri : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaYeri }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Tur Rehberi : {{ item.Odalar[0].Kalem.kalemAcente.Rehber.isim }} </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Gemi Adı : {{ item.Odalar[0].Kalem.kalemAcente.Gemi.isim }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Girişler Dahil : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.Girisler)  }}  </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2" style="max-width:100px;">
                                    <span class="subheading">
                                      Dönüş Bilgileri : {{ item.Odalar[0].Kalem.kalemAcente.DonusBilgisi }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Yemekler Dahil : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.OgleYemegi) }}  </span
                                    >
                                  </td>
                                </tr>
                              
                              </table>
                            </td>
                            <td colspan="4" v-if="isRestaurant">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="4">
                                    <span class="subheading">
                                      Toplam Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="4"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                  v-for="itemMenu in item.Satici.stRestaurant.Menu"
                                  :key="itemMenu.Kod"
                                >
                                  <td colspan="4"       
                                  >
                                    <span class="subheading">
                                      {{ itemMenu.Kod }}  : {{ itemMenu.Menu }}
                                    </span>
                                  </td>
                                </tr>
                         
                              </table>
                            </td>
                            <td colspan="8" v-if="isTransfer">
                             
                              <table align="left" width="100%">
                                   <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                  <tr>
                            <td v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Hareket Tarihi</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Hareket Saati </span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      A/D </span
                                    >
                                  </td>
                                   <td style="width: 10%">
                                    <span class="subheading">
                                      Uçuş No </span
                                    >
                                  </td>
                                    <td style="width: 10%">
                                    <span class="subheading">
                                      Uçuş Saati </span
                                    >
                                  </td>
                                   <td style="width: 15%">
                                    <span class="subheading">
                                      Hareket Yeri </span
                                    >
                                  </td>
                                   <td style="width: 15%">
                                    <span class="subheading">
                                      Varış Yeri </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Araç </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                  </tr>
                                  <tr >
                               <td colspan="8">
                                 <table
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                   width="100%"
                                 >
                                   <tr
                                     v-for="itemkisi in itemoda.Kisiler"
                                     :key="itemkisi.adsoyad"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 15%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.donem1 | dateformat }} 
                                          
                                         </span>
                                     </td>
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.kalemArac.seferSaat | timeformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ADT }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                        {{ itemoda.Kalem.baseKalem.ucusNo }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ucusSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nerden }}
                                       </span>
                                     </td>
                                     <td style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nereye }}
                                       </span>
                                     </td>
                                      <td style="width: 20%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.arac }}
                                       </span>
                                     </td>
                                   </tr>

                                 </table>
                                </td>
                               </tr> 
                      
                              </table>
                            </td>

                            <td colspan="8" v-if="isRentACar">
                              <table align="left" width="100%">
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                <tr>
                                  <td  colspan="8">
                                    <table width="100%">
                                <tr>
                                  <th style="width: 10%"> </th>
                                  <th style="width: 30%">Tarih </th>
                                  <th style="width: 30%">Saat </th>
                                  <th style="width: 30%">Yer </th>
                                </tr>
                                   <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 20%">
                                       <span class="subheading">
                                         Alış Bilgileri
                                         </span>
                                     </td> 
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.alisTarih | dateformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                      <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 10%">
                                       <span class="subheading">
                                         Bırakış Bilgileri
                                         </span>
                                     </td> 
                                     <td style="width: 30%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.musteriTeslimTarihi | dateformat }} </span>
                                     </td>
                                     <td style="width: 30%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 30%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                 <tr style="padding-top: 50px">

                            <td colspan="8" >
                              <table width="100%">
                                <tr>
                                  <th style="width: 100%" colspan="4">Ek Hizmetler </th>
                                  
                                </tr>
                                   <tr
                                     align="left"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 40%" >
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Drop  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDropUcreti) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Otomatik Vites  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkOtomatikVites) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         İptal Sigortası
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkIptalSigortasi) }}
                                       </td>
                                     </tr>
                                    </td>


                                    <td style="width: 40%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Bebek Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkBebekKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Klima  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkKlima) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Navigasyon
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkNavigation) }}
                                       </td>
                                     </tr>
                                    </td>

                                    <td style="width: 20%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Çocuk Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkCocukKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Temizlik  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkTemizlik) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Diğer
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDiger) }}
                                       </td>
                                     </tr>
                                    </td>

                                   </tr>
                                     
                              </table>
                            </td>
                            </tr>
                              </table>
                            </td>
                            
                          </tr>

                          <tr style="height: 100%; padding-top: 50px">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                            <v-divider></v-divider>
                              <span v-if="isOtel || isRestaurant || isTransfer" class="title pt-2 pb-2">
                               İPTAL, NO SHOW VE ERKEN ÇIKIŞ PROSEDURÜ
                              </span>
                              <span v-if="isAcente" class="title pt-2 pb-2">
                               AÇIKLAMALAR
                              </span>
                            <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 5px;
                                padding-bottom: 5px;
                              "
                            >
                              <v-layout id="skip3" justify-end>
                                <v-btn
                                  color="info"
                                  flat
                                  @click="aciklamaDialogOpen('NOT')"
                                >
                                  <v-icon small>edit</v-icon> &nbsp; Not Düzenle
                                </v-btn>
                              </v-layout>
                              {{ selectedVoucherItems.Aciklamalar.Not }}
                            </td>
                          </tr>

                          <tr style="height: 100%">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 5px; padding-bottom: 5px"
                            >
                              <v-divider></v-divider>
                              <span class="title">
                                ŞARTLAR VE KOŞULLAR
                              </span>
                              <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 10px;
                                padding-bottom: 10px;
                              "
                            >
                              <span style="text-align: center">
                                <v-layout id="skip2" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA1')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; Açıklama
                                    1 Düzenle
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama1 }}
                                <br />
                                <v-layout id="skip" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA2')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; Açıklama
                                    2 Düzenle
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama2 }}
                              </span>
                            </td>
                          </tr>
                          <tr></tr>

                          <tr pt-5 style="margin-top: 10px">
                            <td colspan="4">
                              <table width="100%">
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketIsmi
                                    }}
                                  </td>
                                  <td>Rezervasyon Yapan;</td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres1
                                    }}
                                  </td>
                                  <td>
                                    Ad Soyad : &nbsp;
                                    {{ item.RezervasyonYapan.Isim }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres2
                                    }}
                                  </td>
                                  <td>
                                    Email :
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.EMail }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketTelefon
                                    }}
                                  </td>
                                  <td>
                                    Telefon : &nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketFaks
                                    }}
                                  </td>
                                  <td>
                                    Acente : &nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Acente }}
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td></td>
                          </tr>

                          <tr>
                            <td colspan="8">
                              <span class="grey--text caption">
                                {{ getDateNow() | dateformat }}
                                {{ getdatetimenow() }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div id="imgAlt"></div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

          <v-flex xs10 pa-2 sm10 v-if="locale == 'en' && vouchergoster">
              <v-card flat>
                <v-layout justify-end row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <div id="printJS-form">
                      <table
                        style="page-break-after: always"
                        v-for="item in selectedVoucherItems.Sayfalar"
                        :key="item.id"
                        width="100%"
                      >
                        <thead
                          v-if="item.Satici.Kod.trim() == secilenSaticiKod.trim()"
                          class="print"
                        >
                          <tr>
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 100%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                    id="imgUst"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="10"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                              <span v-if="isOtel" class="black--text title">
                                HOTEL VOUCHER</span
                              >
                              <span v-if="isAcente" class="black--text title">
                                AGENCY VOUCHER </span
                              >
                              <span v-if="isRestaurant" class="black--text title">
                                RESTAURANT VOUCHER </span
                              >
                              <span v-if="isTransfer" class="black--text title">
                                TRANSFER VOUCHER </span
                              >
                               <span v-if="isRentACar" class="black--text title">
                                RENT A CAR VOUCHER </span
                              >
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    The-Company Name
                                  </td>

                                  <td style="width: 35%">
                                    {{ item.Satici.Isim }}
                                  </td>

                                  <td style="width: 15%">Telephone</td>

                                  <td style="width: 35%" align="left">
                                    {{ item.Satici.Tel1 }} /
                                    {{ item.Satici.Tel2 }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    The-Company Address
                                  </td>
                                  <td style="width: 35%">
                                    {{ item.Satici.Adres }} &nbsp;
                                    {{ item.Satici.Yer }} &nbsp;
                                    {{ item.Satici.Sehir }} &nbsp;
                                    {{ item.Satici.Ulke }}
                                  </td>
                                  <td style="width: 15%">
                                    Email
                                  </td>
                                  <td style="width: 35%" align="left">-</td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                            </tr>
                            <td v-if="isOtel" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      Room Row</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Pnr No</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Person Type </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Name </span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Entry date</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Release date </span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      Night </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Room type </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                <td v-if="isAcente" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Reservation</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Nationality </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Passport Number </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Date of birth </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-if="isRestaurant" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Pax</span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Against Res. Code </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Nationality </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Passport Number </span
                                    >
                                  </td>
                                    <td style="width: 20%">
                                    <span class="subheading">
                                      Birth Date </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-if="isRentACar" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Vehicle </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Kategori </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Category </span
                                    >
                                  </td>
                                    <td style="width: 20%">
                                    <span class="subheading">
                                      Day </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr v-if="isOtel">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      {{ itemoda.Sira }}</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      {{ KisiTipToStr(itemkisi.kisiTip) }}
                                    </span>
                                  </td>
                                  <td
                                    align="left"
                                    style="align: left; width: 20%"
                                  >
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem1 | dateformat }}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem2 | dateformat }}</span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      {{ gunhesapla(itemoda.Kalem) }}</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{
                                        PansiyonTipToStr(
                                          itemoda.Kalem.kalemOtel.pansiyon
                                        )
                                      }}{{
                                        itemoda.Kalem.kalemOtel.odaTipi.isim
                                      }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>

                          <tr v-if="isAcente">
                            <td colspan="5">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{ itemkisi.kod }}</span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                       {{ itemkisi.ulke }}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{ itemkisi.pasaportNo }}</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi) }} </span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>


                           <tr v-if="isRestaurant">
                            <td colspan="4"  >
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      {{ itemkisi.Pax }} 
                                      </span>
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading"> {{ itemkisi.adSoyad }}</span>
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      {{ pnr }}    
                                    </span>
                                  </td>
                                  <td style="width: 25%" >
                                    <span class="subheading">
                                      {{ itemoda.KarsiRezKodu }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                         <tr v-if="isTransfer">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{itemkisi.ulke}}  
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemkisi.pasaportNo}}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi)}}
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr v-if="isRentACar">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{itemoda.Kalem.baseKalem.arac}} </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.kategori}}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.aracAdet}} 
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.gun}} 
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr>
                            <td v-if="isOtel" colspan="4">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                     Total Passengers : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="8"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Total Rooms : {{ toplamOdaText }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td colspan="5" v-if="isAcente">
                              <table align="left" width="100%">
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Total Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                     Tour Type : {{ getTurTipi(item.Odalar[0].Kalem.kalemAcente.TurTipi) }} </span
                                    >
                                  </td>
                                </tr>
                                 <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Meeting Date : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaTarihi | dateformat }} </span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                       Tour Type : {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.TurTuru) }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Meeting time : {{ item.Odalar[0].Kalem.kalemAcente.Saat | timeformat }} </span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Lap Duration :  </span 
                                    >
                                    <!-- {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.Tip) }} -->
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                     Meeting place : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaYeri }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                     The tour guide : {{ item.Odalar[0].Kalem.kalemAcente.Rehber.isim }} </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Ship name : {{ item.Odalar[0].Kalem.kalemAcente.Gemi.isim }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Entries Included : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.Girisler)  }}  </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2" style="max-width:100px;">
                                    <span class="subheading">
                                      Return Information : {{ item.Odalar[0].Kalem.kalemAcente.DonusBilgisi }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Meals Included : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.OgleYemegi) }}  </span
                                    >
                                  </td>
                                </tr>
                              
                              </table>
                            </td>

                            <td colspan="4" v-if="isRestaurant">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="4">
                                    <span class="subheading">
                                      Toplam Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="4"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                  v-for="itemMenu in item.Satici.stRestaurant.Menu"
                                  :key="itemMenu.Kod"
                                >
                                  <td colspan="4"       
                                  >
                                    <span class="subheading">
                                      {{ itemMenu.Kod }}  : {{ itemMenu.Menu }}
                                    </span>
                                  </td>
                                </tr>
                         
                              </table>
                            </td>
                            <td colspan="8" v-if="isTransfer">
                             
                              <table align="left" width="100%">
                                   <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                  <tr>
                            <td v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Departure date</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Departure time </span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      A/D </span
                                    >
                                  </td>
                                   <td style="width: 10%">
                                    <span class="subheading">
                                      Flight number </span
                                    >
                                  </td>
                                    <td style="width: 10%">
                                    <span class="subheading">
                                      Flight time </span
                                    >
                                  </td>
                                   <td style="width: 15%">
                                    <span class="subheading">
                                      Place of action </span
                                    >
                                  </td>
                                   <td style="width: 15%">
                                    <span class="subheading">
                                      Destination </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Vehicle </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                  </tr>
                                  <tr >
                               <td colspan="8">
                                 <table
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                   width="100%"
                                 >
                                   <tr
                                     v-for="itemkisi in itemoda.Kisiler"
                                     :key="itemkisi.adsoyad"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 15%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.donem1 | dateformat }} 
                                          
                                         </span>
                                     </td>
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.kalemArac.seferSaat | timeformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ADT }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                        {{ itemoda.Kalem.baseKalem.ucusNo }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ucusSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nerden }}
                                       </span>
                                     </td>
                                     <td style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nereye }}
                                       </span>
                                     </td>
                                      <td style="width: 20%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.arac }}
                                       </span>
                                     </td>
                                   </tr>

                                 </table>
                                </td>
                               </tr> 
                      
                              </table>
                            </td>

                            <td colspan="8" v-if="isRentACar">
                              <table align="left" width="100%">
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                <tr>
                                  <td  colspan="8">
                                    <table width="100%">
                                <tr>
                                  <th style="width: 10%"> </th>
                                  <th style="width: 30%">Date </th>
                                  <th style="width: 30%">Hour </th>
                                  <th style="width: 30%">Place </th>
                                </tr>
                                   <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 20%">
                                       <span class="subheading">
                                         Purchase Information
                                         </span>
                                     </td> 
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.alisTarih | dateformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                      <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 10%">
                                       <span class="subheading">
                                         Drop Information
                                         </span>
                                     </td> 
                                     <td style="width: 30%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.musteriTeslimTarihi | dateformat }} </span>
                                     </td>
                                     <td style="width: 30%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 30%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                 <tr style="padding-top: 50px">

                            <td colspan="8" >
                              <table width="100%">
                                <tr>
                                  <th style="width: 100%" colspan="4">Additional services </th>
                                  
                                </tr>
                                   <tr
                                     align="left"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 40%" >
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Drop  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDropUcreti) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Automatic transmission 
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkOtomatikVites) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Cancellation Insurance
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkIptalSigortasi) }}
                                       </td>
                                     </tr>
                                    </td>


                                    <td style="width: 40%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Baby chair  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkBebekKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Air conditioning  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkKlima) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Navigation
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkNavigation) }}
                                       </td>
                                     </tr>
                                    </td>

                                    <td style="width: 20%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                       Child seat 
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkCocukKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Cleaning  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkTemizlik) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Other
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDiger) }}
                                       </td>
                                     </tr>
                                    </td>

                                   </tr>
                                     
                              </table>
                            </td>
                            </tr>
                              </table>
                            </td>
                          </tr>

                          <tr style="height: 100%; padding-top: 50px">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                            <v-divider></v-divider>
                              <span class="title pt-2 pb-2">
                                CANCELLATION, NO SHOW AND EARLY EXIT PROCEDURE
                              </span>
                            <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 5px;
                                padding-bottom: 5px;
                              "
                            >
                              <v-layout id="skip3" justify-end>
                                <v-btn
                                  color="info"
                                  flat
                                  @click="aciklamaDialogOpen('NOT')"
                                >
                                  <v-icon small>edit</v-icon> &nbsp; Not Düzenle
                                </v-btn>
                              </v-layout>
                              {{ selectedVoucherItems.Aciklamalar.Not }}
                            </td>
                          </tr>

                          <tr style="height: 100%">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 5px; padding-bottom: 5px"
                            >
                              <v-divider></v-divider>
                              <span class="title">
                               TERMS AND CONDITIONS
                              </span>
                              <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 10px;
                                padding-bottom: 10px;
                              "
                            >
                              <span style="text-align: center">
                                <v-layout id="skip2" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA1')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; Açıklama
                                    1 Düzenle
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama1 }}
                                <br />
                                <v-layout id="skip" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA2')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; Açıklama
                                    2 Düzenle
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama2 }}
                              </span>
                            </td>
                          </tr>
                          <tr></tr>

                          <tr pt-5 style="margin-top: 10px">
                            <td colspan="4">
                              <table width="100%">
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketIsmi
                                    }}
                                  </td>
                                  <td>Booker;</td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres1
                                    }}
                                  </td>
                                  <td>
                                    Name Surname : &nbsp;
                                    {{ item.RezervasyonYapan.Isim }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres2
                                    }}
                                  </td>
                                  <td>
                                    Email :
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.EMail }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketTelefon
                                    }}
                                  </td>
                                  <td>
                                    Telephone : &nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketFaks
                                    }}
                                  </td>
                                  <td>
                                    Agency : &nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Acente }}
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td></td>
                          </tr>

                          <tr>
                            <td colspan="8">
                              <span class="grey--text caption">
                                {{ getDateNow() | dateformat }}
                                {{ getdatetimenow() }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div id="imgAlt"></div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

           <v-flex xs10 pa-2 sm10 v-if="locale == 'de' && vouchergoster">
              <v-card flat>
                <v-layout justify-end row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <div id="printJS-form">
                      <table
                        style="page-break-after: always"
                        v-for="item in selectedVoucherItems.Sayfalar"
                        :key="item.id"
                        width="100%"
                      >
                        <thead
                          v-if="item.Satici.Kod.trim() == secilenSaticiKod.trim()"
                          class="print"
                        >
                          <tr>
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 100%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                    id="imgUst"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="10"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                              <span v-if="isOtel" class="black--text title">
                                HOTELGUTSCHEIN </span
                              >
                               <span v-if="isAcente" class="black--text title">
                                AGENTEN-GUTSCHEIN </span
                              >
                              <span v-if="isRestaurant" class="black--text title">
                                RESTAURANT-GUTSCHEIN </span
                              >
                              <span v-if="isTransfer" class="black--text title">
                                ÜBERTRAGUNGSGUTSCHEIN </span
                              >
                               <span v-if="isRentACar" class="black--text title">
                                MIETWAGEN-GUTSCHEIN </span
                              >
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    Name der Firma
                                  </td>

                                  <td style="width: 35%">
                                    {{ item.Satici.Isim }}
                                  </td>

                                  <td style="width: 15%">Telefon</td>

                                  <td style="width: 35%" align="left">
                                    {{ item.Satici.Tel1 }} /
                                    {{ item.Satici.Tel2 }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                  Firmenanschrift
                                  </td>
                                  <td style="width: 35%">
                                    {{ item.Satici.Adres }} &nbsp;
                                    {{ item.Satici.Yer }} &nbsp;
                                    {{ item.Satici.Sehir }} &nbsp;
                                    {{ item.Satici.Ulke }}
                                  </td>
                                  <td style="width: 15%">
                                    Email
                                  </td>
                                  <td style="width: 35%" align="left">-</td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                            </tr>
                            <td v-if="isOtel" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      Zimmerreihe</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Pnr No</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Person Typ </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      das Hauptwort </span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Eintrittsdatum</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Veröffentlichungsdatum </span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                     Nacht </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Zimmertyp </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                              <td v-if="isAcente" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Reservierung</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Staatsangehörigkeit </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Ausweisnummer </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                     Geburtsdatum</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-if="isRestaurant" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Pax</span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                     Gegen Res. Code </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Staatsangehörigkeit </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                     Ausweisnummer </span
                                    >
                                  </td>
                                    <td style="width: 20%">
                                    <span class="subheading">
                                      Geburtsdatum </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-if="isRentACar" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Fahrzeug </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Kategorie </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Stück </span
                                    >
                                  </td>
                                    <td style="width: 20%">
                                    <span class="subheading">
                                      Tag </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr v-if="isOtel">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      {{ itemoda.Sira }}</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      {{ KisiTipToStr(itemkisi.kisiTip) }}
                                    </span>
                                  </td>
                                  <td
                                    align="left"
                                    style="align: left; width: 20%"
                                  >
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem1 | dateformat }}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem2 | dateformat }}</span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      {{ gunhesapla(itemoda.Kalem) }}</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{
                                        PansiyonTipToStr(
                                          itemoda.Kalem.kalemOtel.pansiyon
                                        )
                                      }}{{
                                        itemoda.Kalem.kalemOtel.odaTipi.isim
                                      }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>

                            <tr v-if="isAcente">
                            <td colspan="5">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{ itemkisi.kod }}</span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                       {{ itemkisi.ulke }}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{ itemkisi.pasaportNo }}</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi) }} </span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>


                           <tr v-if="isRestaurant">
                            <td colspan="4"  >
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      {{ itemkisi.Pax }} 
                                      </span>
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading"> {{ itemkisi.adSoyad }}</span>
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      {{ pnr }}    
                                    </span>
                                  </td>
                                  <td style="width: 25%" >
                                    <span class="subheading">
                                      {{ itemoda.KarsiRezKodu }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                         <tr v-if="isTransfer">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{itemkisi.ulke}}  
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemkisi.pasaportNo}}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi)}}
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr v-if="isRentACar">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{itemoda.Kalem.baseKalem.arac}} </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.kategori}}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.aracAdet}} 
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.gun}} 
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr>
                            <td v-if="isOtel" colspan="4">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Gesamtzahl der Passagiere : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="8"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Nombre total de chambres : {{ toplamOdaText }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                               <td colspan="5" v-if="isAcente">
                              <table align="left" width="100%">
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Gesamt Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Tourtyp : {{ getTurTipi(item.Odalar[0].Kalem.kalemAcente.TurTipi) }} </span
                                    >
                                  </td>
                                </tr>
                                 <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Datum des Treffens : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaTarihi | dateformat }} </span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Tourtyp : {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.TurTuru) }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Verabredungszeitpunkt : {{ item.Odalar[0].Kalem.kalemAcente.Saat | timeformat }} </span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                     Rundendauer :  </span 
                                    >
                                    <!-- {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.Tip) }} -->
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Treffpunkt : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaYeri }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Der Reiseleiter : {{ item.Odalar[0].Kalem.kalemAcente.Rehber.isim }} </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Schiffsname : {{ item.Odalar[0].Kalem.kalemAcente.Gemi.isim }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                     Einträge enthalten : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.Girisler)  }}  </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2" style="max-width:100px;">
                                    <span class="subheading">
                                      Rücksendeinformationen : {{ item.Odalar[0].Kalem.kalemAcente.DonusBilgisi }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Mahlzeiten inbegriffen : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.OgleYemegi) }}  </span
                                    >
                                  </td>
                                </tr>
                              
                              </table>
                            </td>
                            <td colspan="4" v-if="isRestaurant">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="4">
                                    <span class="subheading">
                                      Gesamt Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="4"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                  v-for="itemMenu in item.Satici.stRestaurant.Menu"
                                  :key="itemMenu.Kod"
                                >
                                  <td colspan="4"       
                                  >
                                    <span class="subheading">
                                      {{ itemMenu.Kod }}  : {{ itemMenu.Menu }}
                                    </span>
                                  </td>
                                </tr>
                         
                              </table>
                            </td>
                            <td colspan="8" v-if="isTransfer">
                             
                              <table align="left" width="100%">
                                   <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                  <tr>
                            <td v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Abreisedatum</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Abfahrtszeit </span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      A/D </span
                                    >
                                  </td>
                                   <td style="width: 10%">
                                    <span class="subheading">
                                      Flugnummer </span
                                    >
                                  </td>
                                    <td style="width: 10%">
                                    <span class="subheading">
                                      Flugzeit </span
                                    >
                                  </td>
                                   <td style="width: 15%">
                                    <span class="subheading">
                                      Ort der Handlung </span
                                    >
                                  </td>
                                   <td style="width: 15%">
                                    <span class="subheading">
                                      Ziel </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Fahrzeug </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                  </tr>
                                  <tr >
                               <td colspan="8">
                                 <table
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                   width="100%"
                                 >
                                   <tr
                                     v-for="itemkisi in itemoda.Kisiler"
                                     :key="itemkisi.adsoyad"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 15%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.donem1 | dateformat }} 
                                          
                                         </span>
                                     </td>
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.kalemArac.seferSaat | timeformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ADT }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                        {{ itemoda.Kalem.baseKalem.ucusNo }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ucusSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nerden }}
                                       </span>
                                     </td>
                                     <td style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nereye }}
                                       </span>
                                     </td>
                                      <td style="width: 20%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.arac }}
                                       </span>
                                     </td>
                                   </tr>

                                 </table>
                                </td>
                               </tr> 
                      
                              </table>
                            </td>

                            <td colspan="8" v-if="isRentACar">
                              <table align="left" width="100%">
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                <tr>
                                  <td  colspan="8">
                                    <table width="100%">
                                <tr>
                                  <th style="width: 10%"> </th>
                                  <th style="width: 30%">Geschichte </th>
                                  <th style="width: 30%">Stunde </th>
                                  <th style="width: 30%">Ort </th>
                                </tr>
                                   <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 20%">
                                       <span class="subheading">
                                         Informationen zum Kauf
                                         </span>
                                     </td> 
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.alisTarih | dateformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                      <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 10%">
                                       <span class="subheading">
                                        Drop-Informationen
                                         </span>
                                     </td> 
                                     <td style="width: 30%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.musteriTeslimTarihi | dateformat }} </span>
                                     </td>
                                     <td style="width: 30%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 30%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                 <tr style="padding-top: 50px">

                            <td colspan="8" >
                              <table width="100%">
                                <tr>
                                  <th style="width: 100%" colspan="4">Ek Hizmetler </th>
                                  
                                </tr>
                                   <tr
                                     align="left"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 40%" >
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Drop  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDropUcreti) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Otomatik Vites  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkOtomatikVites) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         İptal Sigortası
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkIptalSigortasi) }}
                                       </td>
                                     </tr>
                                    </td>


                                    <td style="width: 40%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Bebek Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkBebekKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Klima  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkKlima) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Navigasyon
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkNavigation) }}
                                       </td>
                                     </tr>
                                    </td>

                                    <td style="width: 20%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Çocuk Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkCocukKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Temizlik  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkTemizlik) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Diğer
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDiger) }}
                                       </td>
                                     </tr>
                                    </td>

                                   </tr>
                                     
                              </table>
                            </td>
                            </tr>
                              </table>
                            </td>
                          </tr>

                          <tr style="height: 100%; padding-top: 50px">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                            <v-divider></v-divider>
                              <span class="title pt-2 pb-2">
                                STORNIERUNG, NO SHOW UND VORZEITIGES EXIT-VERFAHREN
                              </span>
                            <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 5px;
                                padding-bottom: 5px;
                              "
                            >
                              <v-layout id="skip3" justify-end>
                                <v-btn
                                  color="info"
                                  flat
                                  @click="aciklamaDialogOpen('NOT')"
                                >
                                  <v-icon small>edit</v-icon> &nbsp; Not Düzenle
                                </v-btn>
                              </v-layout>
                              {{ selectedVoucherItems.Aciklamalar.Not }}
                            </td>
                          </tr>

                          <tr style="height: 100%">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 5px; padding-bottom: 5px"
                            >
                              <v-divider></v-divider>
                              <span class="title">
                               GESCHÄFTSBEDINGUNGEN
                              </span>
                              <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 10px;
                                padding-bottom: 10px;
                              "
                            >
                              <span style="text-align: center">
                                <v-layout id="skip2" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA1')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; Açıklama
                                    1 Düzenle
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama1 }}
                                <br />
                                <v-layout id="skip" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA2')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; Açıklama
                                    2 Düzenle
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama2 }}
                              </span>
                            </td>
                          </tr>
                          <tr></tr>

                          <tr pt-5 style="margin-top: 10px">
                            <td colspan="4">
                              <table width="100%">
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketIsmi
                                    }}
                                  </td>
                                  <td>Bucher;</td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres1
                                    }}
                                  </td>
                                  <td>
                                    Name und Nachname : &nbsp;
                                    {{ item.RezervasyonYapan.Isim }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres2
                                    }}
                                  </td>
                                  <td>
                                    Email :
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.EMail }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketTelefon
                                    }}
                                  </td>
                                  <td>
                                    Telefon : &nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketFaks
                                    }}
                                  </td>
                                  <td>
                                    Agentur : &nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Acente }}
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td></td>
                          </tr>

                          <tr>
                            <td colspan="8">
                              <span class="grey--text caption">
                                {{ getDateNow() | dateformat }}
                                {{ getdatetimenow() }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div id="imgAlt"></div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>


            <v-flex xs10 pa-2 sm10 v-if="locale == 'fr' && vouchergoster">
              <v-card flat>
                <v-layout justify-end row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <div id="printJS-form">
                      <table
                        style="page-break-after: always"
                        v-for="item in selectedVoucherItems.Sayfalar"
                        :key="item.id"
                        width="100%"
                      >
                        <thead
                          v-if="item.Satici.Kod.trim() == secilenSaticiKod.trim()"
                          class="print"
                        >
                          <tr>
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 100%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                    id="imgUst"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="10"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                              <span v-if="isOtel" class="black--text title">
                                BON D'HTEL</span
                              >
                               <span v-if="isAcente" class="black--text title">
                                BON D'AGENT </span
                              >
                              <span v-if="isRestaurant" class="black--text title">
                                BON RESTAURANT </span
                              >
                              <span v-if="isTransfer" class="black--text title">
                                BON DE TRANSFERT </span
                              >
                               <span v-if="isRentACar" class="black--text title">
                                BON DE LOCATION DE VOITURE </span
                              >
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    Nom de l'entreprise
                                  </td>

                                  <td style="width: 35%">
                                    {{ item.Satici.Isim }}
                                  </td>

                                  <td style="width: 15%">Téléphone</td>

                                  <td style="width: 35%" align="left">
                                    {{ item.Satici.Tel1 }} /
                                    {{ item.Satici.Tel2 }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    Adresse de la société
                                  </td>
                                  <td style="width: 35%">
                                    {{ item.Satici.Adres }} &nbsp;
                                    {{ item.Satici.Yer }} &nbsp;
                                    {{ item.Satici.Sehir }} &nbsp;
                                    {{ item.Satici.Ulke }}
                                  </td>
                                  <td style="width: 15%">
                                    Email
                                  </td>
                                  <td style="width: 35%" align="left">-</td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                            </tr>
                            <td v-if="isOtel" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      Chambre en rangée</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Pnr No</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Type de personne </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Nom </span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Date d'entrée</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Date de sortie </span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      Nuit </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Type de chambre </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-if="isAcente" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Nom</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Réservation</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      nationalité </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Numéro de passeport </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Date de naissance</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-if="isRestaurant" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Pax</span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Nom</span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                     Contre Rés. Code </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Nom</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      nationalité </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Numéro de passeport </span
                                    >
                                  </td>
                                    <td style="width: 20%">
                                    <span class="subheading">
                                      Date de naissance </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-if="isRentACar" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Nom</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Véhicule </span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      Catégorie </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Pièce </span
                                    >
                                  </td>
                                    <td style="width: 20%">
                                    <span class="subheading">
                                      Jour </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                          </tr>

                          <tr v-if="isOtel">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      {{ itemoda.Sira }}</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      {{ KisiTipToStr(itemkisi.kisiTip) }}
                                    </span>
                                  </td>
                                  <td
                                    align="left"
                                    style="align: left; width: 20%"
                                  >
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem1 | dateformat }}</span
                                    >
                                  </td>
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem2 | dateformat }}</span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      {{ gunhesapla(itemoda.Kalem) }}</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{
                                        PansiyonTipToStr(
                                          itemoda.Kalem.kalemOtel.pansiyon
                                        )
                                      }}{{
                                        itemoda.Kalem.kalemOtel.odaTipi.isim
                                      }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>

                           <tr v-if="isAcente">
                            <td colspan="5">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{ itemkisi.kod }}</span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                       {{ itemkisi.ulke }}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{ itemkisi.pasaportNo }}</span
                                    >
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi) }} </span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>


                           <tr v-if="isRestaurant">
                            <td colspan="4"  >
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      {{ itemkisi.Pax }} 
                                      </span>
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading"> {{ itemkisi.adSoyad }}</span>
                                  </td>
                                  <td style="width: 25%">
                                    <span class="subheading">
                                      {{ pnr }}    
                                    </span>
                                  </td>
                                  <td style="width: 25%" >
                                    <span class="subheading">
                                      {{ itemoda.KarsiRezKodu }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                         <tr v-if="isTransfer">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{itemkisi.ulke}}  
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemkisi.pasaportNo}}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi)}}
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr v-if="isRentACar">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading"> {{itemoda.Kalem.baseKalem.arac}} </span>
                                  </td>
                                  <td style="width: 20%">
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.kategori}}
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.aracAdet}} 
                                    </span>
                                  </td>
                                  <td style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.gun}} 
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 


                          <tr>
                            <td v-if="isOtel" colspan="4">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                     Nombre total de passagers : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="8"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Total Rooms : {{ toplamOdaText }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td colspan="5" v-if="isAcente">
                              <table align="left" width="100%">
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Total Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Type de visite : {{ getTurTipi(item.Odalar[0].Kalem.kalemAcente.TurTipi) }} </span
                                    >
                                  </td>
                                </tr>
                                 <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Date de la réunion : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaTarihi | dateformat }} </span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Type de visite : {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.TurTuru) }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                     Heure de réunion : {{ item.Odalar[0].Kalem.kalemAcente.Saat | timeformat }} </span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Durée du tour :  </span 
                                    >
                                    <!-- {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.Tip) }} -->
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Lieu de rencontre : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaYeri }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Le guide touristique : {{ item.Odalar[0].Kalem.kalemAcente.Rehber.isim }} </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2">
                                    <span class="subheading">
                                      Nom de bateau : {{ item.Odalar[0].Kalem.kalemAcente.Gemi.isim }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Entrées incluses : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.Girisler)  }}  </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="2" style="max-width:100px;">
                                    <span class="subheading">
                                      Informations de retour : {{ item.Odalar[0].Kalem.kalemAcente.DonusBilgisi }}</span
                                    >
                                  </td>
                                  <td colspan="2">
                                    <span class="subheading">
                                      Repas inclus : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.OgleYemegi) }}  </span
                                    >
                                  </td>
                                </tr>
                              
                              </table>
                            </td>
                            <td colspan="4" v-if="isRestaurant">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td colspan="4">
                                    <span class="subheading">
                                      Total Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="4"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                  v-for="itemMenu in item.Satici.stRestaurant.Menu"
                                  :key="itemMenu.Kod"
                                >
                                  <td colspan="4"       
                                  >
                                    <span class="subheading">
                                      {{ itemMenu.Kod }}  : {{ itemMenu.Menu }}
                                    </span>
                                  </td>
                                </tr>
                         
                              </table>
                            </td>
                            <td colspan="8" v-if="isTransfer">
                             
                              <table align="left" width="100%">
                                   <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                  <tr>
                            <td v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td style="width: 15%">
                                    <span class="subheading">
                                      Date de départ</span
                                    >
                                  </td>
                                  <td style="width: 10%">
                                    <span class="subheading">
                                      Heure de départ </span
                                    >
                                  </td>
                                  <td style="width: 5%">
                                    <span class="subheading">
                                      A/D </span
                                    >
                                  </td>
                                   <td style="width: 10%">
                                    <span class="subheading">
                                      Numéro de vol </span
                                    >
                                  </td>
                                    <td style="width: 10%">
                                    <span class="subheading">
                                      Temps de vol </span
                                    >
                                  </td>
                                   <td style="width: 15%">
                                    <span class="subheading">
                                      lieu d'action </span
                                    >
                                  </td>
                                   <td style="width: 15%">
                                    <span class="subheading">
                                      Destination </span
                                    >
                                  </td>
                                   <td style="width: 20%">
                                    <span class="subheading">
                                      Véhicule </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                  </tr>
                                  <tr >
                               <td colspan="8">
                                 <table
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                   width="100%"
                                 >
                                   <tr
                                     v-for="itemkisi in itemoda.Kisiler"
                                     :key="itemkisi.adsoyad"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 15%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.donem1 | dateformat }} 
                                          
                                         </span>
                                     </td>
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.kalemArac.seferSaat | timeformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ADT }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                        {{ itemoda.Kalem.baseKalem.ucusNo }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ucusSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nerden }}
                                       </span>
                                     </td>
                                     <td style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nereye }}
                                       </span>
                                     </td>
                                      <td style="width: 20%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.arac }}
                                       </span>
                                     </td>
                                   </tr>

                                 </table>
                                </td>
                               </tr> 
                      
                              </table>
                            </td>

                            <td colspan="8" v-if="isRentACar">
                              <table align="left" width="100%">
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                <tr>
                                  <td  colspan="8">
                                    <table width="100%">
                                <tr>
                                  <th style="width: 10%"> </th>
                                  <th style="width: 30%">Histoire </th>
                                  <th style="width: 30%">Heure </th>
                                  <th style="width: 30%">Place </th>
                                </tr>
                                   <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 20%">
                                       <span class="subheading">
                                         Informations d'achat
                                         </span>
                                     </td> 
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.alisTarih | dateformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                      <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 10%">
                                       <span class="subheading">
                                         Informations sur le dépôt
                                         </span>
                                     </td> 
                                     <td style="width: 30%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.musteriTeslimTarihi | dateformat }} </span>
                                     </td>
                                     <td style="width: 30%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 30%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                 <tr style="padding-top: 50px">

                            <td colspan="8" >
                              <table width="100%">
                                <tr>
                                  <th style="width: 100%" colspan="4">Ek Hizmetler </th>
                                  
                                </tr>
                                   <tr
                                     align="left"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 40%" >
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Drop  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDropUcreti) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Otomatik Vites  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkOtomatikVites) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         İptal Sigortası
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkIptalSigortasi) }}
                                       </td>
                                     </tr>
                                    </td>


                                    <td style="width: 40%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Bebek Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkBebekKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Klima  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkKlima) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Navigasyon
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkNavigation) }}
                                       </td>
                                     </tr>
                                    </td>

                                    <td style="width: 20%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Çocuk Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkCocukKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Temizlik  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkTemizlik) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Diğer
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDiger) }}
                                       </td>
                                     </tr>
                                    </td>

                                   </tr>
                                     
                              </table>
                            </td>
                            </tr>
                              </table>
                            </td>
                          </tr>

                          <tr style="height: 100%; padding-top: 50px">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                            <v-divider></v-divider>
                              <span class="title pt-2 pb-2">
                                ANNULATION, NO SHOW ET PROCÉDURE DE SORTIE ANTICIPÉE
                              </span>
                            <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 5px;
                                padding-bottom: 5px;
                              "
                            >
                              <v-layout id="skip3" justify-end>
                                <v-btn
                                  color="info"
                                  flat
                                  @click="aciklamaDialogOpen('NOT')"
                                >
                                  <v-icon small>edit</v-icon> &nbsp; Not Düzenle
                                </v-btn>
                              </v-layout>
                              {{ selectedVoucherItems.Aciklamalar.Not }}
                            </td>
                          </tr>

                          <tr style="height: 100%">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 5px; padding-bottom: 5px"
                            >
                              <v-divider></v-divider>
                              <span class="title">
                                TERMES ET CONDITIONS
                              </span>
                              <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 10px;
                                padding-bottom: 10px;
                              "
                            >
                              <span style="text-align: center">
                                <v-layout id="skip2" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA1')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; Açıklama
                                    1 Düzenle
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama1 }}
                                <br />
                                <v-layout id="skip" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA2')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; Açıklama
                                    2 Düzenle
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama2 }}
                              </span>
                            </td>
                          </tr>
                          <tr></tr>

                          <tr pt-5 style="margin-top: 10px">
                            <td colspan="4">
                              <table width="100%">
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketIsmi
                                    }}
                                  </td>
                                  <td>Booker;</td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres1
                                    }}
                                  </td>
                                  <td>
                                    Name Surname : &nbsp;
                                    {{ item.RezervasyonYapan.Isim }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres2
                                    }}
                                  </td>
                                  <td>
                                    Email :
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.EMail }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketTelefon
                                    }}
                                  </td>
                                  <td>
                                    Téléphone : &nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketFaks
                                    }}
                                  </td>
                                  <td>
                                    Agent : &nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Acente }}
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td></td>
                          </tr>

                          <tr>
                            <td colspan="8">
                              <span class="grey--text caption">
                                {{ getDateNow() | dateformat }}
                                {{ getdatetimenow() }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div id="imgAlt"></div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>



            <v-flex xs2 pa-2 sm2 v-if="vouchergoster">
              <v-card flat>
                <v-layout row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12>
                        <v-btn
                          block
                          @click.native="dialogTaslak = true"
                          color="info"
                          outline
                        >
                          Taslağı Düzenle
                          <v-icon right small>assignment</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <v-btn
                          block
                          color="info"
                          outline
                          @click="LogoKaydet('Üst Logo Seçiniz', 'UstLogo')"
                        >
                          {{ $t('Upper-Logo') }}  <v-icon right small>save</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm12>
                        <v-btn
                          block
                          color="info"
                          @click="LogoKaydet('Alt Logo Seçiniz', 'AltLogo')"
                          outline
                        >
                          {{ $t('Lower-Logo') }} <v-icon right small>save</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm12>
                        <v-btn
                          block
                          @click="onIzlemeOlustur()"
                          color="info"
                          outline
                        >
                          {{ $t('Print') }} <v-icon right small>print</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialogDuzenle" max-width="600px">
      <v-card>
        <v-card-title>{{ dialogEditTitle }} Düzenle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-textarea
                  v-model="dialogEditText"
                  :label="dialogEditTitle"
                ></v-textarea>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="acikalamaDuzenle()"> Kaydet </v-btn>
          <v-btn color="warning" @click.native="dialogDuzenle = false">
            {{$t('Cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTaslak" max-width="600px">
      <v-card>
        <v-card-title>Taslak Bilgileri Düzenleme</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-flex md12 sm12 xs12>
                  <v-textarea
                    v-model="voucherInfo.Aciklamalar.Not"
                    label="Not"
                  ></v-textarea>
                </v-flex>
                <v-flex md12 sm12 xs12>
                  <v-textarea
                    v-model="voucherInfo.Aciklamalar.Aciklama1"
                    label="Aciklama1"
                  >
                  </v-textarea>
                </v-flex>
                <v-flex md12 sm12 xs12>
                  <v-textarea
                    v-model="voucherInfo.Aciklamalar.Aciklama2"
                    label="Aciklama2"
                  >
                  </v-textarea>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="aciklamaKaydet()"> Kaydet </v-btn>
          <v-btn color="warning" @click.native="dialogDuzenle = false">
            {{$t('Cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import rez from "../../rezervasyon";
import printJS from "print-js";
import helpers from "@/components/app/customcomp/helpers.js";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../tools";

import imagefiledialog from "@/components/app/coper/comp/imagefiledialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  components: {
    snackbarcomp,
    yetkidialog,
    imagefiledialog,
    loadingcomp,
  },
  props: ["value"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  data() {
    return {
      tmpSayfalar:[],
      IsimleriAyir:false,
      KalemDetay:false,
      dialogTaslak: false,
      dialogEditTitle: null,
      dialogEditText: null,
      dialogDuzenle: false,
      
      secilenVoucherObje:{
        name:'',
                    value:''  ,
                    raporNo:'',
                    saticiTipi:null,
                    icon: null
      },
      locale: "tr",
      itemsVoucherSaticilar: [],
      locales: [
        {
          locale: "tr",
          title: "Türkçe",
          href: "turkey",
        },
        {
          locale: "en",
          title: "English",
          href: "english",
        },
        {
          locale: "de",
          title: "Deutsch",
          href: "germany",
        },
        {
          locale: "fr",
          title: "French",
          href: "france",
        },
      ],
      loading: false,
      loadingStatus: false,
      snackbar: false,
      mesaj: null,
      dialogform: false,
      isOtel:false,
      isAcente:false,
      isRestaurant:false,
      isTransfer:false,
      isRentACar:false,
      TurTuru:[{
        text: '',
        value: 0
      },
      {
        text: 'Private',
        value: 1
      },
      {
        text: 'Regular',
        value: 2
      },
      {
        text: 'ShorexGroup',
        value: 3
      },
      {
        text: 'PrivateSatis',
        value: 4
      },
      {
        text: 'RegularSatis',
        value: 5
      }
      ],
      pantipitems: [
        {
          text: "",
          value: 0,
        },
        {
          textTR: "Tam",
          textEN: "Full",
          textDE: "Vollständige",
          textFR: "Plein",
          value: 1,
        },
        {
          textTR: "Yarım",
          textEN: "Half",
          textDE: "Hälfte",
          textFR: "Moitié",
          value: 2,
        },
        {
          textTR: "Gece",
          textEN: "Night",
          textDE: "Nacht",
          textFR: "Nuit",
          value: 3,
        },
      ],
      voucherInfo: {
        UstLogoUrl: null,
        AltLogoUrl: null,
        Sayfalar: null,
        SirketBilgileri: null,
        Aciklamalar: {
          Not: null,
          Aciklama1: null,
          Aciklama2: null,
        },
      },
      YedekAciklamalar: {
        Not: null,
        Aciklama1: null,
        Aciklama2: null,
      },
      AltLogoImageUrl: "",
      UstLogoImageUrl: "",
      pnr: null,
      vouchergoster: false,
      voucheritems: [],
      selectedVoucherItems:[],
      secilenSaticiKod:0,
      toplamOdaText: null,
            SaticiIconList: [
        {
          IconName: "hotel",
          Kod: 1,
        },
        {
          IconName: "rv_hookup",
          Kod: 2,
        },
        {
          IconName: "restaurant",
          Kod: 3,
        },
        {
          IconName: "local_see",
          Kod: 4,
        },
        {
          IconName: "departure_board",
          Kod: 5,
        },
        {
          IconName: "emoji_people",
          Kod: 6,
        },
        {
          IconName: "museum",
          Kod: 7,
        },
        {
          IconName: "flight_takeoff",
          Kod: 8,
        },
        {
          IconName: "directions_boat",
          Kod: 9,
        },
        {
          IconName: "category",
          Kod: 10,
        },
        {
          IconName: "style",
          Kod: 11,
        },
        {
          IconName: "tour",
          Kod: 12,
        },
        {
          IconName: "meeting_room",
          Kod: 13,
        },
        {
          IconName: "verified_user",
          Kod: 14,
        },
        {
          IconName: "directions_boat",
          Kod: 15,
        },
        {
          IconName: "golf_course",
          Kod: 16,
        },
      ],
      checkItems: [
        {
          textTR: "",
          textEN: "",
          textDE: "",
          textFR: "",
          value: 0,
        },
        {
          textTR: "Dahil",
          textEN: "Including",
          textDE: "Einschließlich",
          textFR: "Y compris",
          value: 1,
        },
        {
          textTR: "Hariç",
          textEN: "Excluding",
          textDE: "Ausgeschlossen",
          textFR: "Excluant",
          value: 2,
        },
      ],
      KisiTip: [
        {
          Kod: 0,
          AciklamaTR: "Yetişkin",
          AciklamaEN: "Adult",
          AciklamaDE: "Erwachsene",
          AciklamaFR: "Adulte",
        },
        {
          Kod: 1,
          AciklamaTR: "Çocuk 1",
          AciklamaEN: "Child 1",
          AciklamaDE: "Kind 1",
          AciklamaFR: "Enfant 1",
        },
        {
          Kod: 2,
          AciklamaTR: "Çocuk 2",
          AciklamaEN: "Child 2",
          AciklamaDE: "Kind 2",
          AciklamaFR: "Enfant 2",
        },
        {
          Kod: 3,
          AciklamaTR: "Çocuk 3",
          AciklamaEN: "Child 3",
          AciklamaDE: "Kind 3",
          AciklamaFR: "Enfant 3",
        },
        {
          Kod: 4,
          AciklamaTR: "Çocuk 4",
          AciklamaEN: "Child 4",
          AciklamaDE: "Kind 4",
          AciklamaFR: "Enfant 4",
        },
        {
          Kod: 5,
          AciklamaTR: "Ek Yatak",
          AciklamaEN: "Extra Bed",
          AciklamaDE: "Extra Bett",
          AciklamaFR: "Lit supplémentaire",
        },
      ],
      checkValue:[
        {
          textTR:"Evet",
          textEN:"Yes",
          textFR:"Oui",
          textDE:"Ja",
          value:true
        },
        {
          textTR:"Hayır",
          textEN:"No",
          textFR:"Non",
          textDE:"Nein",
          value:false
        }
      ],
      selectedSalerType:0
    };
  },

  created() {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    
    if (this.sayfayetki.Status == true) {
      this.loadingStatus = true;
      this.pnr = this.$route.query.PNR_No;
      this.otelvoucherYazdir(this.$route.query.PNR_No, 0,this.$route.query.Tip);
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
  methods: {
    getVoucher(){
      this.tmpSayfalar=[];
      this.loadingStatus = true;
      this.voucheritems = [];
      this.itemsVoucherSaticilar = [];
      this.selectedVoucherItems = [];
      this.otelvoucherYazdir(this.$route.query.PNR_No, 0,this.$route.query.Tip);
    },
    formatDate(value){
      var date = value.split('-');
      return date[2] + "." + date[1] + "." + date[0]
    },
    checkTrueFalse(val){
      var _checkValue = this.checkValue.find(x => x.value == val);

      switch (this.locale) {
        case "tr":
          return _checkValue.textTR;
        case "en":
          return _checkValue.textEN;
        case "de":
          return _checkValue.textDE;
        case "fr":
          return _checkValue.textFR;
        default:
          break;
      }
    },
    checkItemsList(val){
      var _checkItems = this.checkItems.find(x => x.value == val);
      switch (this.locale) {
        case "tr":
          return _checkItems.textTR;
        case "en":
          return _checkItems.textEN;
        case "de":
          return _checkItems.textDE;
        case "fr":
          return _checkItems.textFR;
        default:
          break;
      }
    },
    getTurTuru(val){
     var _turTuru = this.TurTuru.find(x => x.value == val);
      switch (this.locale) {
        case "tr":
          return _turTuru.text;
        case "en":
          return _turTuru.text;
        case "de":
          return _turTuru.text;
        case "fr":
          return _turTuru.text;
        default:
          break;
      }
    },
    getTurTipi(val){
       var _turTipi = this.pantipitems.find(x => x.value == val);
      switch (this.locale) {
        case "tr":
          return _turTipi.textTR;
        case "en":
          return _turTipi.textEN;
        case "de":
          return _turTipi.textDE;
        case "fr":
          return _turTipi.textFR;
        default:
          break;
      }
    },
  getIconName: function (t) {
      let _resultIcon = null;
      this.SaticiIconList.forEach((element) => {
        if (element.Kod == t) {
          _resultIcon = element.IconName;
        }
      });
      return _resultIcon;
    },
    KisiTipToStr(tip) {
      if (tip == null) {
        tip = 0;
      }
      switch (this.locale) {
        case "tr":
          return this.KisiTip[tip].AciklamaTR;
        case "en":
          return this.KisiTip[tip].AciklamaEN;
        case "de":
          return this.KisiTip[tip].AciklamaDE;
        case "fr":
          return this.KisiTip[tip].AciklamaFR;
        default:
          break;
      }
    },
    voucherLoad2()
    {
      
      // var voucherDetails = this.secilenVoucher.split('-');
      // if(voucherDetails.length == 4){
      //     this.secilenSaticiKod = voucherDetails[0] + "-" + voucherDetails[1];
      // }else{
      //     this.secilenSaticiKod = voucherDetails[0];
      // }
      this.secilenSaticiKod = this.secilenVoucherObje.value;
      switch (this.secilenVoucherObje.saticiTipi) {
          case 1://otel
          this.voucherSet(1);
          break;
          case 2: //arac
          this.voucherSet(2);
          break;
          case 3: //restaurant
          this.voucherSet(3);
          break;
          case 4: //acente
          this.voucherSet(4);
          break;
          case 5://rentacar 
          this.voucherSet(5);
          break;
        default:
          break;
      }

    },
    voucherLoad() {
  
      var voucherDetails = this.secilenVoucherObje;
      
      // if(voucherDetails.length == 4){
      //     this.secilenSaticiKod = voucherDetails[0] + "-" + voucherDetails[1];
      // }else{
      //     this.secilenSaticiKod = voucherDetails[0];
      // }
      this.secilenSaticiKod = this.secilenVoucherObje.value;
      switch (this.secilenVoucherObje.saticiTipi) {
          case 1://otel
          this.voucherSet(1);
          break;
          case 2: //arac
          this.voucherSet(2);
          break;
          case 3: //restaurant
          this.voucherSet(3);
          break;
          case 4: //acente
          this.voucherSet(4);
          break;
          case 5://rentacar 
          this.voucherSet(5);
          break;
        default:
          break;
      }

    },
    voucherSet(Tip){
      this.selectedSalerType = Tip;
    switch (parseInt(Tip)) {

          case 1://otel
         
         
         if (this.IsimleriAyir==true)
         {
          if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.OtelVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.OtelVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.OtelVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.OtelVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.OtelVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.OtelVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.OtelVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.OtelVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.OtelVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.OtelVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

          var _odaText = this.voucherInfo.Sayfalar[0].OdaToplamlari.map(
          function (item) {
            return item.Adet + " " + item.OdaKodu + " ";
          }
          );
          this.toplamOdaText = _odaText.toString();
          this.isAcente = false;
          this.isRentACar = false;
          this.isTransfer = false;
          this.isRestaurant = false;
          this.isOtel = true;
          this.vouchergoster = true;
         }
         else
         {
          this.selectedVoucherItems = this.voucheritems.OtelVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.OtelVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.OtelVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.OtelVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.OtelVoucher.Sayfalar;
          var _odaText = this.voucherInfo.Sayfalar[0].OdaToplamlari.map(
          function (item) {
            return item.Adet + " " + item.OdaKodu + " ";
          }
          );
          this.toplamOdaText = _odaText.toString();
          this.isAcente = false;
          this.isRentACar = false;
          this.isTransfer = false;
          this.isRestaurant = false;
          this.isOtel = true;
          this.vouchergoster = true;
         }

          
         
          break;
          case 2: //arac
if (this.IsimleriAyir==true)
{
  if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.AracVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.AracVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.AracVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.AracVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.AracVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.AracVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.AracVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.AracVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.AracVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.AracVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

        
          this.isAcente = false;
          this.isRentACar = false;
          this.isOtel = false;
          this.isRestaurant = false;
          this.isTransfer = true;
          this.vouchergoster = true;
}
else
{
          this.selectedVoucherItems = this.voucheritems.AracVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.AracVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.AracVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.AracVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.AracVoucher.Sayfalar;
          this.isAcente = false;
          this.isRentACar = false;
          this.isOtel = false;
          this.isRestaurant = false;
          this.isTransfer = true;
          this.vouchergoster = true;
}

         
          break;
          case 3: //restaurant
if (this.IsimleriAyir==true)
{
  if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.RestaurantVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.RestaurantVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.RestaurantVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.RestaurantVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.RestaurantVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.RestaurantVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.RestaurantVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.RestaurantVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.RestaurantVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.RestaurantVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

        
          this.isOtel = false;
          this.isTransfer = false;
          this.isRentACar = false;
          this.isAcente = false;
          this.isRestaurant = true;
          this.vouchergoster = true;
}
else
{
  this.selectedVoucherItems = this.voucheritems.RestaurantVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.RestaurantVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.RestaurantVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.RestaurantVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.RestaurantVoucher.Sayfalar;
          this.isOtel = false;
          this.isTransfer = false;
          this.isRentACar = false;
          this.isAcente = false;
          this.isRestaurant = true;
          this.vouchergoster = true;
}

        
          break;
          case 4: //acente
          if (this.IsimleriAyir==true)
          {
            if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.AcenteVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.AcenteVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.AcenteVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.AcenteVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.AcenteVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.AcenteVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.AcenteVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.AcenteVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.AcenteVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.AcenteVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

        
         this.isRestaurant = false;
          this.isOtel = false;
          this.isTransfer = false;
          this.isRentACar = false;
          this.isAcente = true;
          this.vouchergoster = true;
          }
          else
          {
            this.selectedVoucherItems = this.voucheritems.AcenteVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.AcenteVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.AcenteVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.AcenteVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.AcenteVoucher.Sayfalar;
          this.isRestaurant = false;
          this.isOtel = false;
          this.isTransfer = false;
          this.isRentACar = false;
          this.isAcente = true;
          this.vouchergoster = true;
          }
        
          break;
          case 5://rentacar 
          if (this.IsimleriAyir==true)
          {
            if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.RentACarVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.RentACarVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.RentACarVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.RentACarVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.RentACarVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.RentACarVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.RentACarVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.RentACarVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.RentACarVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.RentACarVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

        
         this.isRestaurant = false;
          this.isOtel = false;
          this.isTransfer = false;
          this.isAcente = false;
          this.isRentACar = true;
          this.vouchergoster = true;
          }
          else
          {
            this.selectedVoucherItems = this.voucheritems.RentACarVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.RentACarVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.RentACarVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.RentACarVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.RentACarVoucher.Sayfalar;
          this.isRestaurant = false;
          this.isOtel = false;
          this.isTransfer = false;
          this.isAcente = false;
          this.isRentACar = true;
          this.vouchergoster = true;
          }
         
          break;
        default:
          break;
      }    

        this.sleep(1000).then(() => {
           this.addUpImage(this.voucherInfo.UstLogoUrl);
           this.addDownImage(this.voucherInfo.AltLogoUrl);
        });

    },
    acikalamaDuzenle() {
      switch (this.dialogEditTitle) {
        case "Not":
          this.voucherInfo.Aciklamalar.Not = this.dialogEditText;
          this.dialogDuzenle = false;
          break;
        case "Açıklama 1":
          this.voucherInfo.Aciklamalar.Aciklama1 = this.dialogEditText;
          this.dialogDuzenle = false;
          break;
        case "Açıklama 2":
          this.voucherInfo.Aciklamalar.Aciklama2 = this.dialogEditText;
          this.dialogDuzenle = false;
          break;
        default:
          break;
      }
    },
    aciklamaDialogOpen(tip) {
      switch (tip) {
        case "NOT":
          this.dialogDuzenle = true;
          this.dialogEditText = this.voucherInfo.Aciklamalar.Not;
          this.dialogEditTitle = "Not";
          break;
        case "ACIKLAMA1":
          this.dialogDuzenle = true;
          this.dialogEditText = this.voucherInfo.Aciklamalar.Aciklama1;
          this.dialogEditTitle = "Açıklama 1";
          break;
        case "ACIKLAMA2":
          this.dialogDuzenle = true;
          this.dialogEditText = this.voucherInfo.Aciklamalar.Aciklama2;
          this.dialogEditTitle = "Açıklama 2";
          break;
        default:
          break;
      }
    },
    addUpImage(imageUrl) {
      if (this.voucherInfo.UstLogoUrl != null) {

        var w=window.innerWidth;
        var newImageUst = document.createElement("img");
    
        if (w<=480){
        newImageUst.style = "width:400;height:200px;display: block;margin: 0 auto;";
        }else if(w <= 768){
        newImageUst.style = "width:700px;height:200px;display: block;margin: 0 auto;";
        }else if(w <= 1024){
        newImageUst.style = "width:700px;height:200px;display: block;margin: 0 auto;";
        }
        else{
        newImageUst.style = "width:1000px;height:200px;";
        }

        newImageUst.src = imageUrl;
        document.getElementById("imgUst").innerHTML = "";
        document.getElementById("imgUst").appendChild(newImageUst);
      }
    },
    addDownImage(imageUrl) {
      if (this.voucherInfo.AltLogoUrl != null) {
        var newImageAlt = document.createElement("img");
        var w=window.innerWidth;

        newImageAlt.src = imageUrl;
        if (w<=480){
        newImageAlt.style = "width:400;height:200px;display: block;margin: 0 auto;";
        }else if(w <= 768){
        newImageAlt.style = "width:700px;height:200px;display: block;margin: 0 auto;";
        }else if(w <= 1024){
        newImageAlt.style = "width:700px;height:200px;display: block;margin: 0 auto;";
        }
        else{
        newImageAlt.style = "width:1000px;height:200px;";
        }
        document.getElementById("imgAlt").innerHTML = "";
        document.getElementById("imgAlt").appendChild(newImageAlt);
      }
    },
    getImages() {
      var params = {
        FileCode: "UstLogo",
      };

      tool.http_post(this, "BinaryFileLoadBase64", params).then((response) => {
        if (response.body.Status == true) {
          if (response.body.data.DosyaUzantisi == ".jpeg") {
            this.voucherInfo.UstLogoUrl =
              "data:image/jpeg;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.voucherInfo.UstLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".jpg") {
            this.voucherInfo.UstLogoUrl =
              "data:image/jpg;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.voucherInfo.UstLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".png") {
            this.voucherInfo.UstLogoUrl =
              "data:image/png;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.voucherInfo.UstLogoUrl);
          }
        }
      });

      var params1 = {
        FileCode: "AltLogo",
      };

      tool.http_post(this, "BinaryFileLoadBase64", params1).then((response) => {
        if (response.body.Status == true) {
          if (response.body.data.DosyaUzantisi == ".jpeg") {
            this.voucherInfo.AltLogoUrl =
              "data:image/jpeg;base64," + response.body.data.imageBase64;
            this.addDownImage(this.voucherInfo.AltLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".jpg") {
            this.voucherInfo.AltLogoUrl =
              "data:image/jpg;base64," + response.body.data.imageBase64;
            this.addDownImage(this.voucherInfo.AltLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".png") {
            this.voucherInfo.AltLogoUrl =
              "data:image/png;base64," + response.body.data.imageBase64;
            this.addDownImage(this.voucherInfo.AltLogoUrl);
          }
        }
      });
    },
    onIzlemeOlustur() {
      this.loadingStatus = true;
      setTimeout(
        function () {
          this.loadingStatus = false;
        }.bind(this),
        2500
      );
      this.sleep(3000).then(() => {
        this.voucheryazdir();
      });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    LogoKaydet(Title, FileCode) {
      this.$refs.imagefiledialog.open(Title, FileCode).then((confirm) => {
        if (confirm !== "") {
          this.voucherLoad();
        }
      });
    },
    getDateNow() {
      return helpers.getDateNow();
    },
    PansiyonTipToStr(tip) {
      return rez.PansiyonTipToStr(tip);
    },
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    },
    getdatetimenow() {
      var timenow = helpers.getTimeNow();

      return String(timenow);
    },

    gunhesapla(val) {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(val.donem1);
      const secondDate = new Date(val.donem2);

      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

      return diffDays;
    },

    denemeyazdir(divName) {
      this.voucheritems.Aciklamalar.Not = this.voucherInfo.Aciklamalar.Not;
      this.voucheritems.Aciklamalar.Aciklama1 =
        this.voucherInfo.Aciklamalar.Aciklama1;
      this.voucheritems.Aciklamalar.Aciklama2 =
        this.voucherInfo.Aciklamalar.Aciklama2;

      var mywindow = window.open("", "PRINT", "height=500,width=700");

      mywindow.document.write("<html><head></head><body>");
      mywindow.document.write(document.getElementById(divName).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      this.sleep(500).then(() => {
        //necessary for image load
        mywindow.print();
        mywindow.close();
      });

      return true;
    },
    voucheryazdir() {
      printJS({
        printable: "printJS-form",
        type: "html",
        ignoreElements: ["skip", "skip2", "skip3"],
      });
    },
    checkKalemDetay(element,voucherSaticilar){
      let controlName = element.Satici.Kod + " - " + element.Satici.Isim;
      return  voucherSaticilar.find((x) => x.name == controlName);
                
    },
    otelvoucherYazdir(val, saticiKod,saticiTip) {
     
      var _tip = saticiTip.split('-');
      var _control = 0;
      var params = {
        PNR_No: val,
        KalemDetay : this.KalemDetay,
        IsimleriAyir:this.IsimleriAyir
      };
      tool.http_post(this, "Voucher", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.voucheritems = response.body.data;

            if(this.voucheritems.AcenteVoucher){
              
            this.voucheritems.AcenteVoucher.Sayfalar.forEach((element) => {
            if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  this.itemsVoucherSaticilar.push({
                    name: " " + element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                    raporNo:element.RaporNo,
                    saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
                
                this.itemsVoucherSaticilar.push({
                name: + element.RaporNo + " " + element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
             
              }
            });
            }

            if(this.voucheritems.AracVoucher){
            this.voucheritems.AracVoucher.Sayfalar.forEach((element) => {
              if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  this.itemsVoucherSaticilar.push({
                    name: element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
              this.itemsVoucherSaticilar.push({
                name: element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
              }
            });
            }

            if(this.voucheritems.OtelVoucher){
            this.voucheritems.OtelVoucher.Sayfalar.forEach((element) => {
              if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  console.log('ekledim');
                  this.itemsVoucherSaticilar.push({
                    
                    name: element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
                console.log('ekledim1');
               this.itemsVoucherSaticilar.push({
                name:  element.RaporNo + " - " + element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
              } 
      
            });
            }

          if(this.voucheritems.RentACarVoucher){
            this.voucheritems.RentACarVoucher.Sayfalar.forEach((element) => {
            if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  this.itemsVoucherSaticilar.push({
                    name: element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
              this.itemsVoucherSaticilar.push({
                name: element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
              }
            });
            }

            if(this.voucheritems.RestaurantVoucher){
            this.voucheritems.RestaurantVoucher.Sayfalar.forEach((element) => {
            if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  this.itemsVoucherSaticilar.push({
                    name: element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                    raporNo:element.RaporNo,
                    saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
              this.itemsVoucherSaticilar.push({
                name: element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
              }
            });
            }

            this.secilenSaticiKod=null;
            console.log(this.itemsVoucherSaticilar);
            this.itemsVoucherSaticilar.forEach(element => {
              
              if(element.saticiTipi == parseInt(_tip) && _control == 0){
                if (this.IsimleriAyir==false)
                {
                    this.secilenVoucherObje.value=element.value;
                    this.secilenVoucherObje.raporNo=element.raporNo;
                    this.secilenVoucherObje.saticiTipi=element.saticiTipi;
                    this.secilenVoucherObje.name=element.name;
                    this.secilenVoucherObje.icon=element.icon;
                _control == 1;
                this.voucherLoad();
                }
              
              }
            });

          

            this.sleep(2000).then(() => {
               this.getImages();
               this.loadingStatus = false;
            });
         

            this.loadingStatus = false;
          }else {
            this.mesaj = response.body.ErrorList[0];
            this.snackbar = true;
            this.vouchergoster = false;
          }
        },
        (response) => {
          this.mesaj = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.vouchergoster = false;
        }
      );
    },
    aciklamaKaydet() {
      var params = {
        Aciklama: this.voucherInfo.Aciklamalar,
        SaticiTipi: this.selectedSalerType,
        RaporTipi: 1,
      };

      tool.http_post(this, "RaporAciklamaKaydet", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.mesaj = "Açıklamalar kaydedildi.";
            this.snackbar = true;
            this.dialogTaslak = false;
          } else {
            this.mesaj = response.body.ErrorList[0];
            this.snackbar = true;
            this.dialogTaslak = false;
          }
        },
        (response) => {
          this.mesaj = "Hata oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.dialogTaslak = false;
        }
      );
    },
  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return  helpers.getTime(t)
    }
  },

  moneyformat: function (m) {
    return helpers.moneyformat(m);
  },

  bakiyekontrol: function (m) {
    return helpers.bakiyekontrol(m);
  },
};
</script>
<style scoped>
img[src=""] {
  display: none;
}
</style>
